<template>
  <div class="json-editor-container">
    <json-editor
      v-model="jsonData"
      :options="editorOptions"
      @error="handleError"
    ></json-editor>
    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
  </div>
</template>

<script>
import { JsonEditor } from 'vue-json-editor';

export default {
  name: 'JsonTrans',
  components: {
    JsonEditor
  },
  data() {
    return {
      jsonData: {},
      errorMessage: '',
      editorOptions: {
        mode: 'tree', // 'tree' or 'view' or 'form'
        // You can add more options here
      }
    };
  },
  methods: {
    handleError(error) {
      this.errorMessage = error.message; // Capture error messages
    }
  }
}
</script>

<style scoped>
.json-editor-container {
  width: 80%;
  height: 200px;
  margin: auto;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.error-message {
  color: red;
  margin-top: 10px;
}
</style>